import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';

const ExecutorSelect = ({ users = [], value = [], onChange, placeholder = 'Выберите исполнителей' }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const wrapRef = useRef(null);

  // Закрытие по клику вне
  useEffect(() => {
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const toggle = (id) => {
    if (value.includes(id)) {
      onChange(value.filter((v) => v !== id));
    } else {
      onChange([...value, id]);
    }
  };

  const remove = (id) => onChange(value.filter((v) => v !== id));

  const selectedUsers = users.filter((u) => value.includes(u._id));
  const filtered = users.filter((u) =>
    u.name?.toLowerCase().includes(query.trim().toLowerCase())
  );

  return (
    <div className="multi-select" ref={wrapRef}>
      <div
        className={`multi-select__control ${open ? 'multi-select__control--open' : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        {selectedUsers.length === 0 && (
          <div><span className="multi-select__placeholder">{placeholder}</span></div>
        )}

        <div className="multi-select__chips">
          {selectedUsers.map((u) => (
            <span key={u._id} className="multi-select__chip">
              {u.name}
              <button
                type="button"
                className="multi-select__chip-x"
                onClick={(e) => { e.stopPropagation(); remove(u._id); }}
                title="Убрать"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </span>
          ))}
        </div>

        <FontAwesomeIcon
          icon={faChevronDown}
          className={`multi-select__arrow ${open ? 'multi-select__arrow--open' : ''}`}
        />
      </div>

      {open && (
        <div className="multi-select__dropdown">
          <input
            className="multi-select__search"
            placeholder="Поиск..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="multi-select__list">
            {filtered.length === 0 && (
              <div className="multi-select__empty">Никого не найдено</div>
            )}
            {filtered.map((u) => {
              const checked = value.includes(u._id);
              return (
                <div
                  key={u._id}
                  className={`multi-select__option ${checked ? 'multi-select__option--checked' : ''}`}
                  onClick={() => toggle(u._id)}
                >
                  <span className="multi-select__option-name">{u.name}</span>
                  {checked && <FontAwesomeIcon icon={faCheck} className="multi-select__option-check" />}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExecutorSelect;